<template>
  <fieldset
    class="border-dotted border rounded border-h-neutral-500 flex flex-col text-center items-center justify-center px-[18px] h-[230px] w-full md:h-[200px] mb-10 max-w-[1113px] mx-auto">
    <div v-if="!imageSelected" class="h-full py-[30px]">
      <div class="mb-2.5">
        <p class="mb-1 font-extrabold text-h-primary-900">
          {{ $t("forum.topic.form.labels.image") }}
        </p>
        <small class="text-sm h-[15px] text-h-neutral-700">
          {{ $t("forum.topic.form.labels.imageRequirements") }}
        </small>
      </div>
      <v-icon name="md-uploadfile" width="48" height="48" class="mb-2 text-h-neutral-600" />
      <label for="imageFileInput"
        class="btn-primary cursor-pointer rounded flex items-center justify-center font-bold w-[65px] px-2 py-1.5 mx-auto mb-[21px]">
        {{ $t("forum.topic.form.buttons.imageSend") }}
      </label>
      <input type="file" id="imageFileInput" class="hidden" @change="changeFile"
        accept="image/*,.jpg,.png,.jpeg,.gif" />
    </div>
    <div v-else
      class="w-[140px] h-[140px] rounded relative flex flex-col items-center justify-center border border-h-primary-700 bg-h-neutral-100">
      <v-icon name="md-image-round" height="40px" width="40px" class="text-h-primary-700" />
      <div class="p-2 text-xs leading-3 text-h-primary-700">
        <span class="break-all line-clamp-3">
          {{
            imageSelected.name ?? $t("labels.generic", {
              pt: "Imagem",
              en: "Image",
            })
          }}
        </span>
        <span v-if="imageSelected?.mimetype">.{{ imageSelected?.mimetype }}</span>
      </div>
      <button
        class="rounded-full flex justify-center items-center absolute -top-1.5 -right-1.5 border-4 w-[18px] h-[18px] border-h-primary-700 bg-white"
        @click="resetImageFile">
        <v-icon name="md-close" width="10px" height="10px" class="text-h-primary-700" />
      </button>
    </div>
  </fieldset>
</template>

<script lang="ts">
import { ToastFactory } from "@/utils/toast-factory.util";
import { Messages } from "@/utils/messages.util";
import { defineComponent} from "vue";


export default defineComponent({
  name: "add-file-input",
  emits:["onSetImage", "onResetImage"],
  props: {
    imageSelected: {
      type: Object,
      require: false,
    },
  },
  methods: {
    changeFile(event: Event): void {
      
      const imageFiles = (event.target as HTMLInputElement).files || null;
      if (imageFiles?.length === 0 || imageFiles === null) return;
      if (this.isImageIncorrect(imageFiles[0])) return;
      this.$emit("onSetImage", imageFiles[0]);
    },
    isImageIncorrect(image: File): boolean {
      if (!this.checkImageSizeRequirement(image)) {
        this.$toast.add(ToastFactory.error(Messages.FORUM_UPLOAD_SIZE_ERROR));
        return true;
      };

      if (!this.checkImageTypeRequirement(image)) {
        this.$toast.add(ToastFactory.error(Messages.FORUM_UPLOAD_TYPE_ERROR));
        return true;
      };

      return false;
    },
    resetImageFile(): void {
      this.$emit("onResetImage");
    },
    checkImageSizeRequirement(image: File): boolean {
      return this.convertBytesToMB(image.size) < 10;
    },
    checkImageTypeRequirement(image: File): boolean {
      const type = image.type.split("/")?.pop();
      return (
        type === "png" || type === "jpg" || type === "jpeg" || type === "gif"
      );
    },
    convertBytesToMB(number: number): number {
      return number / 1e6;
    },
  },
});
</script>
